import { render } from "./EditorShow.vue?vue&type=template&id=b52ac5be"
import script from "./EditorShow.vue?vue&type=script&lang=js"
export * from "./EditorShow.vue?vue&type=script&lang=js"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__